import { Select } from '@genesislcap/foundation-ui';
import { SegmentedControl } from '@genesislcap/foundation-zero';
import { TextField, TextArea, NumberField } from '@microsoft/fast-foundation';
import { EnumTranslate } from '../services/enum.service';
import { convertDateToUTC, formatDateForInput } from './formatting';

export const emptyFieldMessage = 'Please fill out this field';

function getErrorContainer(field: TextField | TextArea | Select | SegmentedControl | NumberField) {
  // If it is in a ranged element (e.g Min - Max Price inputs)
  if (
    field.parentElement?.classList.contains('range-value') ||
    field.parentElement?.classList.contains('long-error') ||
    field.parentElement?.classList.contains('date')
  ) {
    return field.closest('.form-control');
  } else {
    // Selects have to be wrapped in a div to be able to append the error to the parent
    return field instanceof Select ? field.parentElement : field;
  }
}

export function displayErrorUtil(
  field: TextField | TextArea | Select | SegmentedControl | NumberField,
  errorMessage: string = emptyFieldMessage
) {
  const errorContainer = getErrorContainer(field);
  const error = errorContainer.getElementsByClassName('error-message');
  if (error.length) {
    error[0].textContent = errorMessage;
  } else {
    const _error = document.createElement('span');
    _error.textContent = errorMessage;
    _error.setAttribute('class', 'error-message');
    errorContainer.appendChild(_error);
    errorContainer.classList.add('with-error');
  }
}

export function clearErrorUtil(
  field: TextField | TextArea | Select | SegmentedControl | NumberField
) {
  const errorContainer = getErrorContainer(field);
  const error = errorContainer.getElementsByClassName('error-message');
  if (error.length) {
    error[0].remove();
    errorContainer.classList.remove('with-error');
  }
}
export function displayStandingMessageUtil(
  field: TextField | TextArea | Select | SegmentedControl | NumberField,
  standingMessage: string = emptyFieldMessage
) {
  const standingMessageContainer = getErrorContainer(field);
  const message = standingMessageContainer.getElementsByClassName('standing-message');
  if (message.length) {
    message[0].textContent = standingMessage;
  } else {
    const _message = document.createElement('span');
    _message.textContent = standingMessage;
    _message.setAttribute('class', 'standing-message');
    standingMessageContainer.appendChild(_message);
    standingMessageContainer.classList.add('with-standing-message');
  }
}
export function clearStandingMessageUtil(
  field: TextField | TextArea | Select | SegmentedControl | NumberField
) {
  const errorContainer = getErrorContainer(field);
  const error = errorContainer.getElementsByClassName('standing-message');
  if (error.length) {
    error[0].remove();
    errorContainer.classList.remove('with-standing-message');
  }
}

/**
 * updates Guaranteed COD field default to Target COD + 6 months, whenever Target COD is changed
 */
export function updateGuarantedCOD(targetCODValue: string) {
  const _targetCOD = convertDateToUTC(new Date(targetCODValue));
  const _newGuarantedCODUTC = convertDateToUTC(new Date(_targetCOD.setMonth(_targetCOD.getMonth() + 6)));
  _newGuarantedCODUTC.setUTCDate(_newGuarantedCODUTC.getUTCDate() - 1);
  
  const guarantedCODValue = formatDateForInput(_newGuarantedCODUTC.getTime());

  return guarantedCODValue;
}

// return a list without NOT_APPLICABLE option
export function getEnumArrayWithoutNotApplicableValue(
  enumArray: Array<EnumTranslate>
): Array<EnumTranslate> {
  if (enumArray) {
    return enumArray.filter((x) => x.ENUM_VALUE !== 'NOT_APPLICABLE');
  }

  return [];
}
